/** SWPP — Student Work Placement Program. */
export const SWPP_TASKS = [
  {
    id: 1,
    name: "Placement setup",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm employer eligibility with delivery partner", completed: false },
      { id: "1-2", name: "Define student role and placement term", completed: false },
      { id: "1-3", name: "Match with post-secondary institution if required", completed: false },
    ],
  },
  {
    id: 2,
    name: "Funding application",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Submit SWPP application to delivery organization", completed: false },
      { id: "2-2", name: "Receive approval before placement start date", completed: false },
    ],
  },
  {
    id: 3,
    name: "Placement & reimbursement",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Onboard student and document hours", completed: false },
      { id: "3-2", name: "Submit wage subsidy claim with payroll proof", completed: false },
    ],
  },
];

/** BETS — Bridging Entrepreneurs to Students. */
export const BETS_TASKS = [
  {
    id: 1,
    name: "Project scoping",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm client qualifies as growth-oriented SME", completed: false },
      { id: "1-2", name: "Define student project deliverables with client", completed: false },
      { id: "1-3", name: "Connect with participating college/university", completed: false },
    ],
  },
  {
    id: 2,
    name: "Agreement & execution",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Execute BETS funding agreement", completed: false },
      { id: "2-2", name: "Supervise student work and milestone check-ins", completed: false },
    ],
  },
  {
    id: 3,
    name: "Close-out",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Collect final deliverables and student report", completed: false },
      { id: "3-2", name: "Submit final claim and evaluation", completed: false },
    ],
  },
];
